module.exports = require("./NavBarDrawer.vue");